export const medicalModalRegistry = {
    DrugLogStart: () => import("./drug-log/DrugLogStartModal.vue"),
    DrugLogNote: () => import("./drug-log/common/DrugLogNoteModal.vue"),
    ReopenDoneBottles: () => import("./patient-flow/common/reopen-done-bottles/ReopenDoneBottlesModal.vue"),
    EditDrugs: () => import("./patient-flow/common/edit-drugs-modal/EditDrugsModal.vue"),
    RequestHrw: () => import("./patient-flow/common/request-hrw/RequestHrwModal.vue"),
    DeclineSurgery: () => import("./patient-flow/common/decline-surgery-modal/DeclineSurgeryModal.vue"),
    PreOnDone: () => import("./patient-flow/common/on-done-modal/PreOnDoneModal.vue"),
    PostOnDone: () => import("./patient-flow/common/on-done-modal/PostOnDoneModal.vue"),
    WasteDrawn: () => import("./patient-flow/common/waste-drawn/WasteDrawnModal.vue"),
    DrugAction: () => import("./patient-flow/common/drug-action-modal/DrugActionModal.vue"),
    DoneBottle: () => import("./patient-flow/common/drug-action-modal/DoneBottleModal.vue"),
    UpdateAnimal: () => import("./patient-flow/common/update-animal-modal/UpdateAnimalModal.vue"),
    Exam: () => import("./patient-flow/common/exam/ExamModal.vue"),
    HrwVerbal: () => import("./patient-flow/partials/hrw/HrwVerbalModal.vue"),
    AmPrint: () => import("./am-tasks/common/AmPrintModal.vue"),
    TreatmentSheet: () => import("./am-tasks/common/TreatmentSheetModal.vue")
}